import React from 'react';
import './loadingSpinner.css';

const LoadingSpinner = ({ message }) => (
  <div className="loading-spinner-overlay" role="status" aria-live="polite">
    <div className="loading-spinner">
      <div className="spinner-circle" />
      {message ? <div className="loading-message">{message}</div> : null}
    </div>
  </div>
);

export default LoadingSpinner;
